// extracted by mini-css-extract-plugin
export default {"buttonCancel":"FormPaymentQuote_buttonCancel__zPJS4","buttonAdd":"FormPaymentQuote_buttonAdd__rIimT"};